module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chevron_right-ce90de0eff7af160f5ce0c9e3828d5bb.svg";